export const POST_STATUSES = [
  'OPEN',
  'PLANNED',
  'IN_PROGRESS',
  'DONE',
  'DECLINED',
] as const

export type PostStatus = (typeof POST_STATUSES)[number]

export type PostSort = 'popular' | 'recent'

export type RoadmapPost = {
  id: string
  title: string
  description: string
  status: PostStatus
  voteCount: number
  commentCount: number
  hasVoted: boolean
  createdAt: string
}

export type RoadmapComment = {
  id: string
  postId: string
  authorName: string | null
  body: string
  createdAt: string
}

export type RoadmapMeta = {
  total: number
  statusCounts: Record<PostStatus, number>
}

export type StatusMeta = {
  label: string
  dotClass: string
  textClass: string
}

export const STATUS_META: Record<PostStatus, StatusMeta> = {
  OPEN: {
    label: 'Em análise',
    dotClass: 'bg-dune-text-secondary',
    textClass: 'text-dune-text-secondary',
  },
  PLANNED: {
    label: 'Planejado',
    dotClass: 'bg-signal-blue',
    textClass: 'text-signal-blue',
  },
  IN_PROGRESS: {
    label: 'Em desenvolvimento',
    dotClass: 'bg-signal-orange',
    textClass: 'text-signal-orange',
  },
  DONE: {
    label: 'Entregue',
    dotClass: 'bg-signal-green',
    textClass: 'text-signal-green',
  },
  DECLINED: {
    label: 'Não planejado',
    dotClass: 'bg-signal-red',
    textClass: 'text-signal-red',
  },
}
